// public-site/src/App.js
// Linear customer flow: Sign in → Balance → Pay → Confirmation.
// A simple useState state machine (4 screens) keeps the experience obvious for
// non-technical, grieving families — no router needed.

import React, { useState, useCallback } from 'react';
import { clearToken } from './api';
import SignIn from './screens/SignIn';
import Balance from './screens/Balance';
import Pay from './screens/Pay';
import Confirmation from './screens/Confirmation';

export default function App() {
  const [screen, setScreen] = useState('signin');
  const [caseInfo, setCaseInfo] = useState(null);
  const [lastPayment, setLastPayment] = useState(null);

  const handleSignedIn = useCallback((info) => {
    setCaseInfo(info);
    setScreen('balance');
  }, []);

  const handlePaid = useCallback((payment) => {
    setLastPayment(payment);
    setScreen('confirmation');
  }, []);

  const handleSignOut = useCallback(() => {
    clearToken();
    setCaseInfo(null);
    setLastPayment(null);
    setScreen('signin');
  }, []);

  switch (screen) {
    case 'balance':
      return (
        <Balance
          caseInfo={caseInfo}
          onCaseLoaded={setCaseInfo}
          onPay={() => setScreen('pay')}
          onSignOut={handleSignOut}
        />
      );
    case 'pay':
      return (
        <Pay
          caseInfo={caseInfo}
          onPaid={handlePaid}
          onBack={() => setScreen('balance')}
        />
      );
    case 'confirmation':
      return (
        <Confirmation
          payment={lastPayment}
          caseInfo={caseInfo}
          onPayAgain={() => setScreen('balance')}
          onDone={handleSignOut}
        />
      );
    case 'signin':
    default:
      return <SignIn onSignedIn={handleSignedIn} />;
  }
}
